var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 25C20.0751 25 25 20.0751 25 14C25 7.92487 20.0751 3 14 3C7.92487 3 3 7.92487 3 14C3 20.0751 7.92487 25 14 25Z",
    fill: "#504D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 9.302C20.4853 9.52308 19.9314 9.67197 19.3504 9.7392C19.9435 9.39539 20.399 8.85132 20.6131 8.20303C20.0588 8.52151 19.4433 8.75207 18.7896 8.87704C18.2655 8.33748 17.5184 8 16.693 8C15.1069 8 13.8208 9.2434 13.8208 10.7769C13.8208 10.9943 13.8465 11.2063 13.8955 11.4098C11.5082 11.2943 9.39196 10.1885 7.97527 8.50843C7.72794 8.91855 7.58654 9.3954 7.58654 9.90433C7.58654 10.8675 8.09287 11.7175 8.86422 12.2156C8.39288 12.2011 7.95054 12.0762 7.56274 11.8682V11.9029C7.56274 13.2487 8.55342 14.3707 9.86656 14.6265C9.62576 14.6897 9.37189 14.724 9.11015 14.724C8.92488 14.724 8.74475 14.7064 8.56928 14.6739C8.93468 15.777 9.99582 16.58 11.2524 16.6026C10.2697 17.347 9.03128 17.7913 7.68548 17.7913C7.45308 17.7913 7.22447 17.7783 7 17.7521C8.27114 18.5398 9.78069 19 11.4027 19C16.6855 19 19.5744 14.7686 19.5744 11.0994C19.5744 10.9789 19.5721 10.859 19.5661 10.7403C20.1279 10.3478 20.615 9.85876 21 9.302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.2ae5b69d04884e0282a9011372857ade.svg";
export { ForwardRef as ReactComponent };